import bestwayProducts from '@/data/bestway/products.json'
import gastroProducts from '@/data/gastro/products.json'
import salviaProducts from '@/data/salvia/products.json'

import { baseTheme } from './base'

export const themes = {
  bestway: {
    ...baseTheme,
    language: "en",
    currency: '£',
    colors: {
      ...baseTheme.colors,
      global: '#014C6B',
      primary: '#03A58E',
      // Darker accent for text/icons on light backgrounds (WCAG AA)
      primaryText: '#027A69',
      primaryDark: '#00537E',
    },
    font: "'Inter', sans-serif",
    title: 'Bestway',
    // The pharmacy demo is one experience: EN = Bestway (UK), PL = Salvia (Poland)
    languageVariants: { pl: 'salvia' },
    assets: {
      logo: require('@/assets/img/logo_bestway.png'),
      miniLogo: require('@/assets/img/logo_bestway.png'),
    },
    products: bestwayProducts || []
  },
  gastro: {
    ...baseTheme,
    language: "en",
    currency: '£',
    colors: {
      ...baseTheme.colors,
      global: '#1E272E',
      primary: '#E0452A', // deeper coral: white text 4.2:1 (was #FF6348, 2.95:1)
      primaryText: '#C0391F',
      primaryDark: '#161C22',
      green: '#27AE60',
      red: '#E74C3C',
    },
    font: "'Inter', sans-serif",
    title: 'Berg Gastro',
    brandPrefix: true,
    assets: {
      logo: '/img/gastro/logo-berg-white.svg',
      miniLogo: '/img/gastro/logo-berg-white.svg',
    },
    products: gastroProducts || []
  },
  salvia: {
    ...baseTheme,
    language: "pl",
    currency: 'zł',
    vatRate: 0.23,
    colors: {
      ...baseTheme.colors,
      body: '#F2F5F3',
      global: '#1E4638',
      primary: '#2F8A63',
      primaryText: '#23704F',
      primaryDark: '#16362B',
      accent: '#A7DBB9',
    },
    font: "'Nunito Sans', sans-serif",
    title: 'Salvia Apteka',
    languageVariants: { en: 'bestway' },
    brand: {
      name: 'salvia',
      tagline: 'apteka',
    },
    assets: {
      logo: '/img/salvia/mark.svg',
      miniLogo: '/img/salvia/mark.svg',
    },
    products: salviaProducts || []
  },
}

// Theme to show for a client in a given UI language (e.g. bestway + pl -> salvia)
export const resolveTheme = (clientType, language) => {
  const base = themes[clientType] || themes.bestway
  const variant = base.languageVariants?.[language]
  return variant ? themes[variant] : base
}
